import React from 'react';

import PropTypes from 'prop-types';

import { MDash } from 'ui-components/components/mdash/mdash';
import { Text, TextType } from 'ui-components/components/text';

import {
  useSellerFormattedDate,
  useSellerFormattedTime,
  useIsMidnightInSellerTimeZone,
} from '../../../../../../hooks/use-datetime-formats';
import { DateService } from '../../../../../../services/date-service';

import style from './styles.module.less';

export const ReadonlyFulfillmentPlanDate = ({ dateValueUtc, shouldShowTime = false }) => {
  const isMaxDate = DateService.isMaxDate(dateValueUtc);
  const effectiveDateValueUtc = isMaxDate ? undefined : dateValueUtc;
  const formattedEntityDate = useSellerFormattedDate(effectiveDateValueUtc) ?? undefined;
  const formattedEntityTime = useSellerFormattedTime(effectiveDateValueUtc, true) ?? undefined;
  const isMidnightInSellerTimeZone = useIsMidnightInSellerTimeZone(effectiveDateValueUtc);
  const datetime =
    effectiveDateValueUtc && !isMidnightInSellerTimeZone ? `${formattedEntityDate} ${formattedEntityTime}` : formattedEntityDate;

  const dateString = shouldShowTime ? datetime : formattedEntityDate;
  return (
    <Text className={style['shipment-details-date-read-only-content']} textType={TextType.Paragraph} value={dateString ?? <MDash />} />
  );
};

ReadonlyFulfillmentPlanDate.propTypes = {
  dateValueUtc: PropTypes.string,
  shouldShowTime: PropTypes.bool,
};
